import React from "react";

export const VeriCopyright = () => {
  return <>&copy; {new Date().getFullYear()} Verivest. All rights reserved.</>;
};
